import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiService } from '../../../services/api';
import { queryKeys } from '../../../hooks/useApi';
import type { SmartSortingSummaryResponse } from '../../../types/api';

const POLL_INTERVAL = 4000;

export function useSmartSortingSummary() {
  const queryClient = useQueryClient();

  const query = useQuery<SmartSortingSummaryResponse>({
    queryKey: queryKeys.smartSorting.summary,
    queryFn: () => apiService.getSmartSortingSummary(),
    staleTime: 30_000,
    refetchOnMount: 'always',
  });

  const hasProcessing = (query.data?.processing_count ?? 0) > 0;

  useEffect(() => {
    if (!hasProcessing) return;

    const interval = setInterval(() => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.smartSorting.summary,
      });
    }, POLL_INTERVAL);

    return () => clearInterval(interval);
  }, [hasProcessing, queryClient]);

  return query;
}
